import React, { PureComponent } from 'react';
import { CloseOutlined, EditOutlined, SyncOutlined } from '@ant-design/icons';
import { Icon } from '@ant-design/compatible';
import {
  Table,
  Switch,
  Popover,
  Select,
  Tag,
  Divider,
  Modal,
  Button,
  Tooltip,
  Spin,
  Row,
  Col,
  Card,
  message,
} from 'antd';
import { connect } from 'dva';
import { Link } from 'dva/router';
import { router } from 'umi';
import { userCan } from '../../utils/authority';
import { formatDateAndTime, truncateString } from '@/utils/utils';
import { PATH_DASHBOARD } from '@/utils/routes/path';
import moment from 'moment';
import { COLOR } from '@/utils/color';
import AccountName from './AccountName';
import StatusConnections from './EditCloudAccountV2/StatusConnections';
import { showDeleteConfirm } from './EditCloudAccountV2/showDeleteConfirm';

const { confirm } = Modal;

@connect(({ organisation, cloudAccount, user }) => ({
  organisation: organisation.current,
  cloudAccount,
  packageExpiry: organisation.packageExpiry,
  userRole: user.authority,
  allCloudAccountsList: cloudAccount.allCloudAccountsList,
}))
class CloudAccountsTable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      allCloudAccountsList: [],
      showModal: false,
      showTemporaryModal: false,
    };
  }

  handleVisibleChange = visible => {
    this.setState({ visible });
  };

  completedStatus = record => {
    let { eagleEye } = record;
    let { status } = eagleEye;
    return status === 'completed' ? true : false;
  };
  TemporaryStatus = record => {
    let { eagleEye } = record;
    let { status } = eagleEye;
    return status === 'temporary' ? false : true;
  };
  componentDidMount() {
    this.renderCloudAccList();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.allCloudAccountsList !== this.props.allCloudAccountsList) {
      this.renderCloudAccList();
    }
  }
  renderProviderLogo = (provider, accName, userkeys, awsAccountId = '', isActive) => {
    return <AccountName accountData={{ provider, accName, userkeys, awsAccountId, isActive }} />;
  };

  renderCloudAccList = () => {
    const { packageExpiry, allCloudAccountsList } = this.props;
    const dataSource = allCloudAccountsList.map(eachlist => {
      return {
        XRayScanStatus: eachlist.XRayScan?.status || '',
        xrayScanFinishedDate: eachlist.XRayScan?.lastScan,
        awsAccountId: eachlist.awsAccountId,
        orgId: eachlist.orgId,
        provider: eachlist.provider,
        accountName: eachlist.accountName,
        key: `k${eachlist.id}`,
        cloudAccountId: eachlist.id,
        monitoringPopUp: eachlist.monitoringPopUp !== undefined ? eachlist.monitoringPopUp : false,
        accountDetail: this.renderProviderLogo(
          eachlist.provider,
          eachlist.accountName,
          eachlist.userkeys,
          eachlist?.awsAccountId,
          eachlist?.isActive
        ),
        connectionStatus: (
          <StatusConnections
            testConnectionTypes={eachlist?.testConnectionTypes}
            lastHealthCheck={eachlist?.lastHealthCheck}
            provider={eachlist.provider}
            lastScan={eachlist.lastScan}
            isActive={eachlist.isActive}
            protectionLevel={eachlist.protectionLevel}
            id={eachlist.id}
          />
        ),
        customerId: eachlist.customerId,
        userId: eachlist.userId,
        intervalStatus: true,
        status: eachlist.status,
        eagleEye: eachlist.eagleEye,
        live_monitoring: eachlist.live_monitoring,
        interval: !eachlist.interval ? false : eachlist.interval,
        defaultChecked: !eachlist.interval ? false : eachlist.interval == 'Off' ? false : true,
        checkSwitch: !eachlist.interval ? false : eachlist.interval == 'Off' ? false : true,
        SelectInterval: eachlist.interval == 'Off' ? 'Select Interval' : eachlist.interval,
        protectionLevel: eachlist.protectionLevel ? eachlist.protectionLevel : 'None',
        lastScan: eachlist.lastScan,
        isActive: eachlist.isActive,
      };
    });
    this.setState(state => {
      return {
        ...state,
        allCloudAccountsList: dataSource,
      };
    });
  };

  showPopUp(id, value) {
    const updatedList = this.state.allCloudAccountsList.map(item => {
      if (item.key === id) {
        return {
          ...item,
          monitoringPopUp: true,
        };
      }
      return item;
    });
    this.setState(state => {
      return {
        ...state,
        allCloudAccountsList: updatedList,
      };
    });
  }

  /* function calls when switch turn on */
  switchTurnOn(id, accountName, cloudAccountId, userId, value) {
    if (value == false) {
      let intervalTurnOff = {
        key: id,
        userId: userId,
        monitoringPopUp: value,
        accountName: accountName,
        cloudAccountId: cloudAccountId,
        interval: 'Off',
        intervalStatus: value,
      };
      /* update fireStore through dispatch */
      this.props.saveDocs(intervalTurnOff);

      const updatedList = this.state.allCloudAccountsList.map(item => {
        if (item.key === id) {
          item.checkSwitch = false;
          item.monitoringPopUp = false;
          item.interval = 'Off';

          return {
            ...item,
            SelectInterval: 'Select Interval',
          };
        }
        return item;
      });
      this.setState(state => {
        return {
          ...updatedList,
          monitoringPopUp: value,
        };
      });
    } else {
      const updatedList = this.state.allCloudAccountsList.map(item => {
        if (item.key === id) {
          item.checkSwitch = true;
          return {
            ...item,
            monitoringPopUp: value,
            SelectInterval: 'Select Interval',
          };
        }
        return item;
      });
      this.setState(state => {
        return {
          ...state,
          allCloudAccountsList: updatedList,
        };
      });
    }
  }

  disableEagleEye(cloudAccountId) {
    let { dispatch, organisation } = this.props;
    dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'disable-eagleEye',
          orgId: organisation.id,
          id: cloudAccountId,
        },
      },
    });
  }

  enableEagleEye(cloudAccountId) {
    let { dispatch, organisation } = this.props;
    dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'enable-eagle-Eye',
          orgId: organisation.id,
          id: cloudAccountId,
        },
      },
    });
  }

  /*  popup close onclick close symbol X */
  async ClosePopup(e, id, interval) {
    const updatedList = this.state.allCloudAccountsList.map(item => {
      if (item.key === id) {
        item.defaultChecked = false;
        if (interval == 'Off') {
          item.checkSwitch = false;
        } else {
          item.checkSwitch = true;
        }
        return {
          ...item,
          monitoringPopUp: false,
        };
      }
      return item;
    });
    await this.setState(state => {
      return {
        ...state,
        allCloudAccountsList: updatedList,
      };
    });
  }

  testEagleEye = cloudAccount => {
    let { dispatch, organisation } = this.props;
    dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'eagleEye',
          orgId: organisation.id,
          id: cloudAccount,
        },
      },
    });
  };

  /*  when user select any interval */
  selectIntervalClosePopup(e, rawData) {
    let userSelectedvalue = {
      ...rawData,
      interval: e,
      monitoringPopUp: false,
      SelectInterval: e,
    };

    this.setState(state => {
      return {
        ...state,
        allCloudAccountsList: state.allCloudAccountsList.map(row =>
          row.key === userSelectedvalue.key ? userSelectedvalue : row
        ),
      };
    });

    this.props.saveDocs(userSelectedvalue);
  }

  deleteAccount(userRecord, b) {
    const DelThisAccount = {
      userId: userRecord.cloudAccountId,
      cloudAccount: userRecord.accountName,
    };
    this.props.deleteAccount(DelThisAccount);
  }

  editAccount(userRecord, params) {
    const editThisAccount = {
      userId: userRecord.cloudAccountId,
      cloudAccount: userRecord.customerId,
    };
  }

  showDeleteConfirm(userRecord) {
    // getting function from props to use in onOk() function
    const { deleteAccount } = this.props;
    let { dispatch } = this.props;
    const DelThisAccount = {
      userId: userRecord.cloudAccountId,
      cloudAccount: userRecord.accountName,
    };
    confirm({
      title: `Are you sure you want to delete cloud account ${userRecord.accountName}?`,
      // content: 'Some descriptions',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteAccount(DelThisAccount);
        dispatch({
          type: 'cloudAccount/selectRemove',
          payload: userRecord.id,
        });
      },
      onCancel() {},
    });
  }

  handleDeleteAccount = async cloudAccountData => {
    const { dispatch } = this.props;
    await dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'delete',
          id: cloudAccountData.cloudAccountId,
          orgId: cloudAccountData.orgId,
        },
      },
    });

    await dispatch({
      type: 'cloudAccount/selectRemove',
      payload: cloudAccountData.cloudAccountId,
    });

    message.success('Cloud Account Deleted Successfully');
    Modal.destroyAll();
  };

  handleDisbaledAccount = async cloudAccountData => {
    const { dispatch } = this.props;

    await dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'updateIsActiveKey',
          provider: cloudAccountData.provider,
          orgId: cloudAccountData.orgId,
          id: cloudAccountData.cloudAccountId,
        },
        data: {
          isActive: false,
        },
      },
    });

    await dispatch({
      type: 'cloudAccount/selectRemove',
      payload: cloudAccountData.cloudAccountId,
    });

    message.success('Cloud Account Disabled Successfully');
    Modal.destroyAll();
  };

  showUpdateStatusModal(record, checked) {
    let { dispatch } = this.props;
    confirm({
      title: `Are you sure you want to ${checked ? 'activate' : 'deactivate'} ${
        record.accountName
      } cloud account?`,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      centered: true,
      onOk() {
        dispatch({
          type: 'cloudAccount/update',
          payload: {
            params: {
              type: 'updateIsActiveKey',
              provider: record.provider,
              orgId: record.orgId,
              id: record.cloudAccountId,
            },
            data: {
              isActive: checked,
            },
          },
        });
      },
      onCancel() {},
    });
  }

  handleOk = () => {
    // setIsModalVisible(false);
    let { dispatch, organisation } = this.props;
    let { cloudAccountId } = this.state;

    dispatch({
      type: 'cloudAccount/removeEagleEyeConfig',
      payload: {
        params: {
          orgId: organisation.id,
          id: cloudAccountId,
        },
      },
    });
    this.setState({ showModal: false });
  };

  handleCancel = () => {
    // setIsModalVisible(false);
    let { dispatch, organisation } = this.props;
    let { cloudAccountId } = this.state;

    dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'disable-eagleEye-temporary',
          orgId: organisation.id,
          id: cloudAccountId,
        },
      },
    });
    this.setState({ showModal: false });
  };

  handleTemporaryCancel = () => {
    // setIsModalVisible(false);
    let { dispatch, organisation } = this.props;
    let { cloudAccountId } = this.state;

    dispatch({
      type: 'cloudAccount/removeEagleEyeConfig',
      payload: {
        params: {
          // type: 'disable-eagleEye-temporary',
          orgId: organisation.id,
          id: cloudAccountId,
        },
      },
    });
    this.setState({ showTemporaryModal: false });
    const cloudAccRealTimeAlertPath = PATH_DASHBOARD.setup.cloudAccountsRealTimeAlerts;
    router.push(
      `${cloudAccRealTimeAlertPath}?orgId=${this.props.organisation.id}&&cloud-account=${cloudAccountId}`
    );
  };

  handleTemporaryOk = () => {
    // setIsModalVisible(false);
    let { dispatch, organisation } = this.props;
    let { cloudAccountId } = this.state;

    dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'revive-temporary',
          orgId: organisation.id,
          id: cloudAccountId,
        },
      },
    });
    this.setState({ showTemporaryModal: false });
  };

  showTemporaryModal = cloudAccountId => {
    this.setState({ showTemporaryModal: true, cloudAccountId });
  };

  showDisableConfirm = cloudAccountId => {
    this.setState({ showModal: true, cloudAccountId });
  };

  closeModal = () => {
    this.setState({ showModal: false, showTemporaryModal: false });
  };

  render() {
    const { userRole, packageExpiry } = this.props;
    const columns = [
      {
        title: <div style={{ marginLeft: '24px' }}> Account Name</div>,
        dataIndex: 'accountDetail',
        key: 'accountDetail',
        render: (_, record) => {
          return <div style={{ marginLeft: '24px' }}> {record.accountDetail}</div>;
        },
      },
      {
        title: 'Last Scanned',
        dataIndex: 'lastScan',
        key: 'lastScan',
        render: (_, record) => {
          const isScanRunning =
            record.status === 'running-scan' ||
            record.status === 'start-scan' ||
            record.XRayScanStatus === 'running-scan' ||
            record.XRayScanStatus === 'start-scan';

          let relativeTime;
          let popoverInfo;
          let latestScanDate;

          // Check if both dates are valid
          const basicScanFinished = record.lastScan?.toDate();
          const xrayScanFinishedDate = record.xrayScanFinishedDate?.toDate();
          // If scan is running, show the start time and popover content same
          if (isScanRunning) {
            popoverInfo = `Started at ${formatDateAndTime(new Date()).exactTime}`;
          } else if (
            (!isNaN(basicScanFinished) && basicScanFinished instanceof Date) ||
            (!isNaN(xrayScanFinishedDate) && xrayScanFinishedDate instanceof Date)
          ) {
            // Compare both dates and select the latest one
            if (basicScanFinished instanceof Date && xrayScanFinishedDate instanceof Date) {
              latestScanDate =
                record.protectionLevel.toLowerCase() == 'advanced'
                  ? xrayScanFinishedDate > basicScanFinished
                    ? xrayScanFinishedDate
                    : basicScanFinished
                  : basicScanFinished;
            } else {
              latestScanDate = basicScanFinished || xrayScanFinishedDate;
            }
            // If scan is not running, show the latest scan time and popover content
            relativeTime = formatDateAndTime(latestScanDate).relativeTime;
            popoverInfo = `Last scanned at ${formatDateAndTime(latestScanDate).exactTime}`;
          } else {
            // If scan is not running and no valid last scan time, show unavailable message
            popoverInfo = 'Last scan information unavailable';
            relativeTime = 'N/A';
          }

          return (
            <Popover content={<span style={{ fontSize: '0.8rem' }}>{popoverInfo}</span>}>
              {isScanRunning ? (
                <span>
                  <span style={{ fontSize: '0.8rem', marginRight: 8 }}>Running Scan</span>
                  <SyncOutlined spin style={{ fontSize: '1rem', color: COLOR.ACTIVE }} />
                </span>
              ) : (
                <span>{relativeTime}</span>
              )}
            </Popover>
          );
        },
      },

      {
        title: 'Protection Level',
        width: 200,
        dataIndex: 'protectionLevel',
        key: 'protectionLevel',
        render: (_, record) => {
          return (
            <div>
              {record.protectionLevel && record.protectionLevel.toLowerCase() === 'advanced'
                ? 'Advanced'
                : 'Basic'}
            </div>
          );
        },
      },

      {
        title: 'Connection Status',
        dataIndex: 'connectionStatus',
        width: 200,
        key: 'connectionStatus',
        render: (_, record) => {
          return (
            <div
              style={{
                width: 100,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {record.connectionStatus}
            </div>
          );
        },
      },
      {
        title: 'Monitoring',
        key: 'monitioring',
        dataIndex: 'interval',
        render: (_, rowData) => {
          const { Option } = Select;

          return (
            <div
              onClick={e => e.stopPropagation()} // Prevent row click propagation
            >
              <Popover
                content={
                  <div
                    onClick={e => e.stopPropagation()} // Prevent row click from Popover content
                  >
                    <Select
                      style={{ width: '128px' }}
                      defaultValue={rowData.SelectInterval}
                      value={rowData.SelectInterval}
                      onSelect={(value, event) => {
                        if (event && event.domEvent) {
                          event.domEvent.stopPropagation(); // Prevent row click
                        }
                        this.selectIntervalClosePopup(value, rowData);
                      }}
                    >
                      <Option value="daily">Daily</Option>
                      <Option value="weekly">Weekly</Option>
                      <Option value="monthly">Monthly</Option>
                    </Select>
                  </div>
                }
                title={
                  <div
                    onClick={e => e.stopPropagation()} // Prevent row click from Popover title
                  >
                    <div style={{ float: 'right' }}>
                      <CloseOutlined
                        onClick={event => {
                          event.stopPropagation(); // Ensure row click is stopped
                          this.ClosePopup(event, rowData.key, rowData.interval);
                        }}
                      />
                    </div>
                    Schedule Interval
                  </div>
                }
                trigger="click"
                visible={rowData.monitoringPopUp}
                onVisibleChange={visible => {
                  this.handleVisibleChange(visible);
                }}
              />
              <Tooltip
                title={
                  packageExpiry === 'expired'
                    ? 'You can not enable monitoring because your package has expired. Contact support.'
                    : rowData.defaultChecked
                    ? 'Enabled'
                    : 'Disabled'
                }
              >
                <Switch
                  size="small"
                  checkedChildren="On"
                  unCheckedChildren="Off"
                  defaultChecked={rowData.defaultChecked}
                  checked={rowData.checkSwitch}
                  disabled={!userCan('enable-monitoring')}
                  onChange={(value, event) => {
                    if (event && event.stopPropagation) {
                      event.stopPropagation(); // Prevent row click propagation
                    }
                    if (packageExpiry !== 'expired') {
                      this.switchTurnOn(
                        rowData.key,
                        rowData.accountName,
                        rowData.cloudAccountId,
                        rowData.userId,
                        value
                      );
                    }
                  }}
                />
              </Tooltip>
            </div>
          );
        },
      },

      {
        title: 'Actions',
        key: 'action',
        dataIndex: 'id',
        render: (_, record) => {
          return (
            <div style={{ marginLeft: 12 }}>
              <div
                style={{ marginLeft: 12 }}
                onClick={() => {
                  // Redirect to the edit page
                  if (packageExpiry !== 'expired' && userCan('update-cloud-account')) {
                    router.push(
                      `${PATH_DASHBOARD.setup.cloudAccountsEdit}?cloudaccount=${record.cloudAccountId}`
                    );
                  } else {
                    // Redirect to dashboard if package is expired or user lacks permissions
                    router.push(PATH_DASHBOARD.setup.cloudAccounts);
                  }
                }}
              ></div>
              <Tooltip
                title={
                  record.status === 'running-scan' || record.status === 'start-scan'
                    ? 'You cannot delete a Cloud Account while the scan is running!'
                    : packageExpiry === 'expired'
                    ? 'You can not delete Cloud Account because your package has been expired. Contact support'
                    : !userCan('delete-cloud-account')
                    ? "You don't have permission to delete cloud account"
                    : 'Delete Cloud Account'
                }
              >
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault(); // Prevent default anchor behavior
                    e.stopPropagation(); // Stop the event from bubbling to the row's onClick handler

                    if (
                      record.status !== 'running-scan' &&
                      record.status !== 'start-scan' &&
                      packageExpiry !== 'expired' &&
                      userCan('delete-cloud-account')
                    ) {
                      showDeleteConfirm(
                        () => this.handleDeleteAccount(record),
                        () => this.handleDisbaledAccount(record),
                        {
                          showDisableAction: record.isActive,
                          cloudAccountName: record.accountName,
                        }
                      );
                    }
                  }}
                >
                  <img
                    alt="Delete icon"
                    style={{ width: 18, marginLeft: 14 }}
                    src="/icons/delete_icon.svg"
                  />
                </a>
              </Tooltip>
            </div>
          );
        },
      },
    ];

    const { allCloudAccountsList } = this.state;

    let filteredArr = allCloudAccountsList.filter(v => v.status === 'born');

    if (filteredArr.length) {
      return <Spin size="large" />;
    }

    return (
      <div>
        <>
          {this.props.cloudAccount?.allCloudAccountsListLoaded ? (
            <Table
              key="index"
              style={{
                backgroundColor: 'white',
                borderColor: 'white',
                border: 'none',
              }}
              columns={columns}
              dataSource={allCloudAccountsList}
              size="middle"
              locale={{
                emptyText: 'No cloud accounts.',
              }}
              onRow={record => ({
                onClick: () => {
                  // Redirect to the edit page when a row is clicked
                  if (packageExpiry !== 'expired' && userCan('update-cloud-account')) {
                    router.push(
                      `${PATH_DASHBOARD.setup.cloudAccountsEdit}?cloudaccount=${record.cloudAccountId}`
                    );
                  } else {
                    router.push(PATH_DASHBOARD.setup.cloudAccounts);
                  }
                },
                style: {
                  cursor: 'pointer', // Indicate row is clickable
                },
              })}
            />
          ) : (
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <Spin size="large" />
            </div>
          )}
        </>
        <Modal
          title="Disable eagle eye? (Real-Time Alerts)"
          visible={this.state.showModal}
          onOk={false}
          onCancel={this.closeModal}
          okText="delete permanently"
          cancelText="disable temprary"
          closable={true}
          destroyOnClose={true}
          footer={null}
        >
          <Card title="Disable temporarily?" size="small" style={{ marginBottom: 7, fontSize: 12 }}>
            <div>
              Temporarily disable real-time changes detection on cloudnosys for this cloud account.
              You can turn this back on easily from this dashboard. Best for when you are performing
              bulk changes in your cloud.
            </div>
            <Button style={{ marginTop: 10 }} type="primary" onClick={this.handleCancel}>
              Disable Temporarily
            </Button>
          </Card>

          <Card
            title="Disable permanently?"
            // headStyle={{ paddingTop: 5, paddingBottom: 5 }}
            size="small"
            style={{ fontSize: 12 }}
          >
            <div>
              Permanently disable real-time changes detection for this cloud account. To re-enable,
              you will need to perform all the required actions again.
            </div>
            <b style={{ fontSize: 14 }}>
              <u>Note:</u>
            </b>{' '}
            <br />
            To terminate the continuation of billing, you must delete the created stack from your
            cloud account provider (AWS/AZURE/GCP) otherwise it may continue to charge you.
            <div>
              1) On the StackSets page, select the eagle-eye-your-org-name stack set that you
              created while setting up EagleEye.
            </div>
            <div>2) With the stack set selected, choose Delete StackSet from the Actions menu.</div>
            <div>
              3) When you are prompted to confirm that you want to delete the stack set, choose
              Delete StackSet.
            </div>
            <a
              target="_blank"
              href="https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/stacksets-delete.html"
            >
              Further details related to stack set deletion
            </a>
            <br />
            <Button style={{ marginTop: 10 }} type="primary" onClick={this.handleOk}>
              Disable Permanently
            </Button>
          </Card>
        </Modal>
        <Modal
          title="Temporary disabled eagle eye available"
          visible={this.state.showTemporaryModal}
          onOk={false}
          onCancel={this.closeModal}
          closable={true}
          destroyOnClose={true}
          footer={null}
        >
          <p>Do you want to revive eagle eye old setup or enable new one? </p>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              style={{ borderColor: '#6DC92E', color: '#6DC92E' }}
              onClick={this.handleTemporaryCancel}
            >
              Setup new eagle eye{' '}
            </Button>
            <Button type="primary" style={{ marginLeft: 10 }} onClick={this.handleTemporaryOk}>
              Revive old settings
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default CloudAccountsTable;
